export default __webpack_public_path__ + "static/media/c13.8e9b9fcc.png";